import { Component } from "@angular/core";

@Component({
    selector: 'app-more-landing',
    template: require('./morelanding.html')
})
export class MoreLandingComponent {
    constructor() {

    }
}

